import { stringSearch } from '@luminovo/design-system';
import { createFileRoute, redirect } from '@tanstack/react-router';

import type { PageStaticData } from '@/shared/routing';

// The builder used to stay here after its first save with `?templateId=`, so that URL opens the saved one.
export const Route = createFileRoute('/_authenticated/templates/quotation/create')({
    // Only redirects: the builder checks its own access.
    staticData: { access: 'authenticated', chrome: 'none' } satisfies PageStaticData,
    validateSearch: stringSearch({ templateId: 'optional' }),
    beforeLoad: ({ search }) => {
        throw redirect({
            to: '/templates/quotation/builder/{-$templateId}',
            params: { templateId: search.templateId },
            replace: true,
        });
    },
});
